module.exports = __webpack_public_path__ + "img/fiat-2012-calendar-teaser-05.3141768c.jpg";